import {
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DialogHeader from "../../../components/Dialog/DialogHeader";
import UserDialog from "../../../components/Dialog/UserDialog";
import { Api } from "../../../request/api/api";
import { useFieldChange } from "../../../userHooks/useFieldChange";
import { Injury } from "../../../model/Dto/Injury";

interface State {
  name: string;
  injuryId: string | undefined;
}

export interface AddInjuryDialogProps {
  fighterId: string;
  open: boolean;
  fetchData: () => void;
  onClose: () => void;
}

export default function AddInjuryDialog({
  fighterId,
  onClose,
  fetchData,
  open,
}: AddInjuryDialogProps) {
  const [injuryInfo, setInjuryInfo] = React.useState<State>({
    name: "",
    injuryId: undefined,
  });
  const handleChange = useFieldChange(injuryInfo, setInjuryInfo);
  const [inputError, setInputError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [injuries, setInjuries] = useState<Injury[] | undefined>(undefined);

  const changeDialogInfo = (result: Injury[]) => {
    setLoading(false);
    setInjuries(result);
    if (result.length > 0) {
      setInjuryInfo({
        ...injuryInfo,
        injuryId: result[0].id.toString(),
        name: result[0].name, // Автоматически подставляем название травмы
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    Api.dict
      .getAllInjuries()
      .then((result) => changeDialogInfo(result))
      .catch(() => setLoading(false));
  }, []);

  const injuryInfoIsCorrect = () => {
    const result = injuryInfo.name.length >= 3 && injuryInfo.injuryId !== undefined;
    if (!result) {
      setInputError(true);
    }
    return result;
  };

  const handleAdd = async () => {
    if (injuryInfoIsCorrect()) {
      setLoading(true);
      const result = await Api.fighter.addInjury(
        fighterId,        injuryInfo.injuryId!,
      );
      setLoading(false);
      if (result) {
        onClose();
        fetchData();
      } else {
        setInputError(true);
      }
    }
  };

  const handleInjuryChange = (event: SelectChangeEvent) => {
    const selectedInjuryId = event.target.value as string;
    const selectedInjury = injuries?.find(injury => injury.id.toString() === selectedInjuryId);
    
    setInjuryInfo({
      ...injuryInfo,
      injuryId: selectedInjuryId,
      name: selectedInjury ? selectedInjury.name : injuryInfo.name,
    });
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInjuryInfo({
      ...injuryInfo,
      name: event.target.value,
    });
  };

  return (
    <UserDialog handleClose={onClose} open={open}>
      <DialogHeader
        loading={loading}
        title="Добавить травму бойца"
      />
      <DialogContent sx={{ minHeight: "200px" }}>
        <Stack spacing={2}>
          {!injuries ? (
            <div>Загрузка...</div>
          ) : (
            <FormControl variant="filled" sx={{ mt: 2, minWidth: 120 }}>
              <InputLabel>Тип травмы</InputLabel>
              <Select
                autoFocus
                value={injuryInfo.injuryId || ''}
                onChange={handleInjuryChange}
                label="Тип травмы"
                inputProps={{
                  name: "injury-type",
                  id: "injury-type",
                }}
              >
                {injuries.map((injury, index) => (
                  <MenuItem key={index} value={injury.id.toString()}>
                    {injury.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Закрыть</Button>
        <Button onClick={handleAdd} variant="contained" color="primary">
          Добавить травму
        </Button>
      </DialogActions>
    </UserDialog>
  );
}